import { t } from "@/i18n-js/instance";
import { LineItem } from "./LineItem";

const localeRoot = "pricing_plans.plan_settings.plan_summary";

interface CurrentPlanCreditProps {
  currentPlanCredit: string;
}

export const CurrentPlanCredit = ({
  currentPlanCredit,
}: CurrentPlanCreditProps) => (
  <LineItem
    description={t([localeRoot, "current_plan_credit"])}
    value={currentPlanCredit}
    valueProps={{ color: "text-green-success" }}
  />
);
